import { createSlice } from "@reduxjs/toolkit";
import {
  showLeaveRegistration,
  showLeaveRegistrationByEmployeeOid,
  showLeaveSummary,
  showLeaveSummaryByEmployeeOid,
  createLeaveRegistration,
  showLeaveRegistrationData,
  getLeaveApproval,
  cancelLeaveRegistration,
  getLeaveDeclarant,
  getLeaveSummary,
} from "../actions";

const initialState = {
  leaveRegistrationData: [],
  leaveRegistration: [],
  leaveSummary: [],
  leaveApproval: [],
  leaveDeclarant: [],
  loading: false,
  errMsg: null,
  errType: null,
};

const leaveSlice = createSlice({
  name: "leave",
  initialState,
  reducers: {},
  extraReducers: {
    [showLeaveRegistrationData.fulfilled]: (state, action) => {
      state.leaveRegistrationData = action.payload || [];
    },
    [showLeaveRegistrationByEmployeeOid.fulfilled]: (state, action) => {
      state.leaveRegistration = action.payload || [];
    },
    [showLeaveSummary.fulfilled]: (state, action) => {
      state.leaveSummary = action.payload || [];
    },
    [showLeaveSummaryByEmployeeOid.fulfilled]: (state, action) => {
      state.leaveSummary = action.payload || [];
    },
    [createLeaveRegistration.fulfilled]: (state, action) => {
      state.leaveRegistration = action.payload || [];
    },
    [getLeaveApproval.pending]: (state) => {
      state.loading = true;
    },
    [getLeaveApproval.fulfilled]: (state, action) => {
      state.leaveApproval = action.payload || [];
      state.loading = false;
    },
    [getLeaveApproval.rejected]: (state) => {
      state.loading = false;
    },
    [showLeaveRegistration.pending]: (state) => {
      state.loading = true;
    },
    [showLeaveRegistration.fulfilled]: (state, action) => {
      state.leaveRegistration = action.payload || [];
      state.loading = false;
    },
    [showLeaveRegistration.rejected]: (state) => {
      state.loading = false;
    },

    [cancelLeaveRegistration.pending]: (state) => {
      state.loading = true;
    },
    [cancelLeaveRegistration.fulfilled]: (state, action) => {
      state.leaveRegistration.map((item) =>
        item.Oid === action.payload.Oid ? action.payload : item
      );
      state.loading = false;
    },
    [cancelLeaveRegistration.rejected]: (state, action) => {
      state.loading = false;
      state.errMsg = action.payload.message;
      state.errType = action.payload.type ? action.payload.type : "error";
    },

    [getLeaveDeclarant.pending]: (state) => {
      state.loading = true;
    },
    [getLeaveDeclarant.fulfilled]: (state, action) => {
      state.leaveDeclarant = action.payload || [];
      state.loading = false;
    },
    [getLeaveDeclarant.rejected]: (state) => {
      state.loading = false;
    },

    [getLeaveSummary.pending]: (state) => {
      state.loading = true;
    },
    [getLeaveSummary.fulfilled]: (state, action) => {
      state.leaveSummary = [action.payload] || [];
      state.loading = false;
    },
    [getLeaveSummary.rejected]: (state) => {
      state.loading = false;
    },
  },
});

export const responseLeave = (state) => state.leave;

export default leaveSlice.reducer;
